<template>
  <v-dialog :value="AppStateStore.getMessageDialog" persistent max-width="600">
    <v-card text>
      <v-card-title class="justify-center text-center text-wrap">
        {{ AppStateStore.getMessage }}
      </v-card-title>
      <v-card-actions class="pa-0 ma-0">
        <v-btn
          color="primary"
          block
          tile
          @click="AppStateStore.removeMessage()"
        >
          {{ $t("dialog_ok") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { useAppStateStore } from "@store/appState.js";
export default {
  name: "MessageDialog",
  setup() {
    const AppStateStore = useAppStateStore();
    return { AppStateStore };
  },
};
</script>
